export const getDeviceFingerPrint = () => {
  // On Android WebView they must manually enable localStorage on their end when creating the WebView
  // We must check in this case if it exisits inside the window
  if (window.localStorage === null || window.localStorage === undefined) {
    return generateUUID();
  }
  // Check if a token already exists in local storage
  let token = localStorage.getItem("deviceToken");

  if (!token) {
    // If no token exists, generate a new one
    token = generateUUID();

    // Store the new token in local storage
    localStorage.setItem("deviceToken", token);
  }

  return token;
};

// Fallback UUID generation function
export const generateUUID = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  } else {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }
};
